














import Vue, { PropType } from 'vue';
import {
  Image,
  genDownloadImageUrlByImage,
  sizes,
} from '@/modules/image';

interface DataType {
  logoSrc: string | null;
  imageSrc: string | null;
  loading: boolean;
}

export default Vue.extend({
  name: 'GBrandCard',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    name: {
      type: String as PropType<string>,
      default: 'ブランド',
    },
    logo: {
      type: Object as PropType<Image>,
    },
    image: {
      type: Object as PropType<Image>,
    },
    onClickEdit: {
      type: Function as PropType<Function>,
    },
  },
  data(): DataType {
    return {
      logoSrc: '',
      imageSrc: '',
      loading: false,
    };
  },
  methods: {
    // async getImageSrc(cid: string) {
    async getImageSrc() {
      try {
        this.loading = true;
        this.logoSrc = await genDownloadImageUrlByImage(
          sizes.x128,
          this.logo,
        );
        this.imageSrc = await genDownloadImageUrlByImage(
          sizes.x256,
          this.image,
        );
      } catch (error: any) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    if (!this.$auth.cid) return;
    await this.getImageSrc();
  },
});
